<template>
  <div class="full-screen" style="z-index: 10;">
    <!-- <div class="header-nav">
      <div class="left">
        <a class="lk-back" @click="returnPage">返回</a>
      </div>
    </div> -->
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">找回账号</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>


    <div class="login">
      <ul>
        <li>
          <p>说明：如果通过此方式未能自主找回您的充值账号，则请联系客服（11:00 ~ 18:00）帮忙找回！</p>
          <label>选择充值扣款日期（支付宝/微信的扣款日期）</label>
          <div>
            <Calendar v-on:choseDay="clickDay"></Calendar>
          </div>
        </li>
      </ul>

      <!-- 下面是错误提示 -->
      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">找回账号</button>
      </div>
    </div>

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>充值账号找回成功</h3>
        <div class="find-success">
          <p>账号：<strong>{{account}}</strong></p>
          <p>密码：<strong>{{password}}</strong></p>
          <p style="color:red">请务必截屏保存好您的账号!!!</p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="login" style="width: auto;padding: 0 10px">我已保存，直接登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Calendar from "vue-calendar-component";
  import userService from "../../../services/userService";

  export default {
    name: "findAccount",
    data() {
      return {
        chargeTime: '',
        errorMsg: {
          show: false,
          msg: ''
        },
        showModal: false,
        account: '',
        password: ''
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      },
      clickDay(data) {
        this.chargeTime = data;
      },
      validate() {
        if (this.chargeTime === '') {
          this.errorMsg = {show: true, msg: '请选择您的充值扣款日期'}
        } else {
          this.findAccount();
        }
      },
      findAccount() {
        userService.findAccount(this.chargeTime)
          .then(res => {
            if (res.result) {
              this.account = res.data.account;
              this.password = res.data.password;
              this.showModal = true;
            } else {
              let errMsg = res.msg;
              if (res.code == "404") {
                errMsg = "对不起，您的充值账号未找到，您可以联系客服帮忙找回（客服在线时间：11:00 ~ 18:00）";
              }
              this.errorMsg = {show: true, msg: errMsg};
            }
          })
      },
      login() {
        userService.login(this.account, this.password)
          .then(res => {
            if (res.result) {
              this.showModal = false;
              this.$router.isBack = false;
              this.$router.push('/user');
            } else {
              this.errorMsg = {show: true, msg: '账户或密码不正确'}
            }
          })
      }
    },
    components: {
      Calendar
    },
    mounted() {
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/find-account.vue